import { MenuProps } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';

import BaseSemanticLink from '@base/BaseSemanticLink';
import useI18n from '@i18n';

import { ResolvedNavItem } from '../interfaces';

import navBarStyles from '../components/NavBar/index.module.scss';

type MenuItem = Required<MenuProps>['items'][number];

/** Matches the 2px active indicator height so popup starts below the red line */
const SUBMENU_POPUP_OFFSET_Y = 2;

const renderLabel = (
    item: ResolvedNavItem,
    t: ReturnType<typeof useI18n>['t'],
    showChevron = false,
    isPopupItem = false,
) => {
    const content = (
        <span id={!item.href ? item.testId : undefined} className="flex items-center">
            {t(item.labelKey)}
            {item.icon && <img className="ml-2" src={item.icon} alt="" />}
            {!!item.badge && (
                <span className="p-1 ml-1 text-center text-white bg-red-500 px-1.5 min-w-4 text-overline leading-full">
                    {item.badge}
                </span>
            )}
            {showChevron && (
                <FontAwesomeIcon icon={faChevronDown} className={navBarStyles.submenuArrow} />
            )}
        </span>
    );

    if (!item.href) return content;

    return (
        <BaseSemanticLink
            id={item.testId}
            to={item.href}
            className={
                isPopupItem ? 'block w-full no-underline text-inherit' : 'flex items-center h-full'
            }
        >
            {content}
        </BaseSemanticLink>
    );
};

const mapToAntdMenuItems = (
    items: ResolvedNavItem[],
    t: ReturnType<typeof useI18n>['t'],
): MenuProps['items'] =>
    items.map<MenuItem>(item => {
        const hasChildren = Boolean(item.children?.length);

        return {
            key: item.id,
            label: renderLabel(item, t, hasChildren),
            ...(hasChildren
                ? {
                      popupOffset: [0, SUBMENU_POPUP_OFFSET_Y],
                  }
                : {}),
            children: item.children?.map(child => ({
                key: child.id,
                label: renderLabel(child, t, false, true),
            })),
        };
    });
export default mapToAntdMenuItems;
